export enum DocumentTypeDTO {
  RUSSIAN_PASSPORT = 'RUSSIAN_PASSPORT',
  FOREIGN_PASSPORT = 'FOREIGN_PASSPORT'
}
